import { useCallback } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { EventsFormValues } from './eventsForm.constants'

interface UseEventsFormHandlersProps {
  setFieldValue: (field: keyof EventsFormValues, value: any) => void
  setDateError: (error: boolean) => void
}

export const useEventsFormHandlers = ({ setFieldValue, setDateError }: UseEventsFormHandlersProps) => {
  const handleTitleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue('title', e.target.value)
    },
    [setFieldValue]
  )

  const handlePlaceChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue('place', e.target.value)
    },
    [setFieldValue]
  )

  const handleManagerChange = useCallback(
    (e: any) => {
      setFieldValue('manager', e.target.value as string)
    },
    [setFieldValue]
  )

  const handleSiteChange = useCallback(
    (e: any) => {
      setFieldValue('site', e.target.value as string)
    },
    [setFieldValue]
  )

  const handleDateChange = useCallback(
    (d: Dayjs | null) => {
      const validDate = d && dayjs.isDayjs(d) ? d : null
      setFieldValue('date', validDate)
      if (validDate) {
        setDateError(false)
      }
    },
    [setFieldValue, setDateError]
  )

  return {
    handleTitleChange,
    handlePlaceChange,
    handleManagerChange,
    handleSiteChange,
    handleDateChange,
  }
}
